import { render, staticRenderFns } from "./ConfirmNewPasswordView.vue?vue&type=template&id=1b0f37c1&scoped=true&"
import script from "./ConfirmNewPasswordView.vue?vue&type=script&lang=js&"
export * from "./ConfirmNewPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNewPasswordView.vue?vue&type=style&index=0&id=1b0f37c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f37c1",
  null
  
)

export default component.exports